<template>
	<img v-if='!blockData.is_initial' :src="`https://mql-dashboard-maps.s3.us-west-2.amazonaws.com/static/maps/${mapName}/desktop/files/block_${blockData.missions.length}.png`" class='is-desktop-img'>
	<img v-else :src="`https://mql-dashboard-maps.s3.us-west-2.amazonaws.com/static/maps/${mapName}/desktop/files/block_${blockData.missions.length}_level.png`" class='is-desktop-img'>
	<img v-if='!blockData.is_initial' :src="`https://mql-dashboard-maps.s3.us-west-2.amazonaws.com/static/maps/${mapName}/mobile/files/block_${blockData.missions.length}.png`" class='is-mobile-img'>
	<img v-else :src="`https://mql-dashboard-maps.s3.us-west-2.amazonaws.com/static/maps/${mapName}/mobile/files/block_${blockData.missions.length}_level.png`" class='is-mobile-img'>
</template>

<script>
	import Helper from '../../Helper';

	export default {
		props: {
			blockData: Object,
			mapName: String
		},
	}
</script>